// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2gCqf","inputWrap":"CustomTip_inputWrap__3wWZq"};